var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_32434_14480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.20988 25.513C9.84572 25.513 10.3612 24.9976 10.3612 24.3617C10.3612 23.7259 9.84572 23.2104 9.20988 23.2104C8.57404 23.2104 8.05859 23.7259 8.05859 24.3617C8.05859 24.9976 8.57404 25.513 9.20988 25.513Z",
    stroke: "#B08C3D",
    strokeWidth: 2.30257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8739 25.513C22.5098 25.513 23.0252 24.9976 23.0252 24.3617C23.0252 23.7259 22.5098 23.2104 21.8739 23.2104C21.2381 23.2104 20.7227 23.7259 20.7227 24.3617C20.7227 24.9976 21.2381 25.513 21.8739 25.513Z",
    stroke: "#B08C3D",
    strokeWidth: 2.30257,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.35938 2.54443H4.66195L7.72437 16.8434C7.83671 17.3671 8.12809 17.8352 8.54835 18.1672C8.96862 18.4992 9.49148 18.6743 10.0269 18.6624H21.2865C21.8105 18.6616 22.3186 18.482 22.7268 18.1534C23.135 17.8247 23.4189 17.3667 23.5315 16.8549L25.4311 8.30086",
    stroke: "#B08C3D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6797 1.88379V11.8616",
    stroke: "#B08C3D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6914 6.87305L15.6803 11.862L20.6692 6.87305",
    stroke: "#B08C3D",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_32434_14480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.6309,
    height: 27.6309,
    fill: "white",
    transform: "translate(0 0.18457)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInShoppingCart);
export default __webpack_public_path__ + "static/media/in-shopping-cart.4a11594210b276243a44efdb00e420cb.svg";
export { ForwardRef as ReactComponent };